<mat-form-field class="inputassign" appearance="none" flex color="accent">
    <mat-label>Deliverable</mat-label>
    <mat-select [(ngModel)]="value" [(value)]="value" [disabled]="disabled" (openedChange)="onOpen($event)"
    (selectionChange)="onValChange($event)"
        name="allocation_id" #allocation_id="ngModel" [required]="isRequired" >
        <mat-option *ngIf="items === null || !items?.length" class="minh88" disabled>
            <div class="select-placeholder-container">
                <mat-spinner class="spinner" diameter="20"></mat-spinner>
            </div>
        </mat-option>
        <mat-option *ngFor="let item of items" [value]="item">{{item.Title}}</mat-option>
    </mat-select>
    <mat-icon [matTooltip]="' Select the appropriate allocation.'" matTooltipPosition="above"
        class="ng-scope md-iwgNavbar-theme material-icons">
        help
    </mat-icon>
    <mat-error *ngIf="!allocation_id.valid && allocation_id.touched && isRequired">Required</mat-error>
</mat-form-field>
